import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { Injectable } from '@angular/core';
import { Headers, Http, Jsonp, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { environment } from '../../../environments/environment';
import { AuthBody } from '../model/authBody';
import { AuthResponse } from '../model/authResponse';
import { ErrorResponse } from '../model/errorResponse';
import { SessionService } from './session.service';

import * as fileSaver from 'file-saver';

const API_URL = environment.apiUrl;

@Injectable()
export class ExportsService {
	constructor(private http: Http, private sessionService: SessionService) { }

	public exportUsers(organisation: string): Observable<any> {
		const options = new RequestOptions({
			headers: new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('token') }),
			responseType: ResponseContentType.Blob
		});

		return this.http.get(API_URL + '/v1/exports/users?organisation=' + organisation, options)
			.map(response => {
				const body = (<any>response)._body;
				let blob: any = new Blob([body]);
				fileSaver.saveAs(blob, 'export.xlsx');

				return response;
			})
			.catch(this.handleError.bind(this));
	}

	private handleError(error: Response | any) {
		console.log(error);
		return this.sessionService.handleAuthenticatedRequestError(error);
	}
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/services/exports.service.ts